module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image10-a419700c6643047a6d31701c10e3b405.png";